export const environment = {
  stage: process.env.NX_ENV_STAGE,
  liffId: process.env.NX_LIFF_ID,
  basePrefix: process.env.NX_BASE_PREFIX,
  api: {
    payshop: {
      proxyPrefix: process.env.NX_API_PROXY_PREFIX_PAYSHOP,
      serviceId: process.env.NX_API_HEADERS_SERVICE_ID,
    },
    common: {
      proxyPrefix: process.env.NX_API_PROXY_PREFIX_COMMON,
    },
  },
  positionKey: {
    homePromotionArea: process.env.NX_HOME_PROMOTION_AREA_POSITION_KEY,
  },
  externalUrl: {
    inquiry: process.env.NX_INQUIRY_URL,
    faq: {
      ios: process.env.NX_IOS_FAQ_URL,
      aos: process.env.NX_AOS_FAQ_URL,
    },
    lineUniversal: process.env.NX_LINE_UNIVERSAL_URL,
    liff: process.env.NX_LIFF_URL,
    tos: process.env.NX_TOS_URL,
  },
  uts: {
    appEnv: process.env.NX_UTS_APP_ENV,
  },
  sellerKey: {
    starbucks: process.env.NX_STARBUCKS_SELLER_KEY,
  },
};
